export default __webpack_public_path__ + "static/media/line.295069b6.svg";